import { useEffect } from "react";

// Redirects the current route to an external URL (used for the iubenda
// Privacy Policy / Cookie Policy so we don't keep duplicated/obsolete texts).
export const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return (
    <div className="flex min-h-[50vh] items-center justify-center text-sm text-muted-foreground" data-testid="external-redirect">
      Reindirizzamento in corso…
    </div>
  );
};

export default ExternalRedirect;
